import { useState } from 'react';

import { NavigationOverlay } from './navigation-overlay.style';
import MiniNav from './mini/mini-nav';
import NavigationHeaderGuest from './vertical/navigation-header-guest';

const NavigationSmallGuest = () => {
  const [isActive, setIsActive] = useState<boolean>(false);

  return (
    <>
      <NavigationHeaderGuest isActive={isActive} setIsActive={setIsActive} />
      <NavigationOverlay
        $isActive={isActive}
        aria-hidden
        onClick={() => setIsActive(false)}
      />
      <MiniNav isActive={isActive} onClickMenu={() => setIsActive(false)} />
    </>
  );
};

export default NavigationSmallGuest;
